import React, { useCallback, useEffect } from 'react';
import { Button, Col, FlexboxGrid, Grid, Row } from 'rsuite';
import { useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import Header from '../components/singlePermit/Header';
import PortalHeader from '../components/layout/PortalHeader';
import PropertyContacts from '../components/singlePermit/propertyContacts/PropertyContacts';
import ReportingHistory from '../components/singlePermit/reportingHistory/ReportingHistory';
import usePlaceNavigate from '../hooks/usePlaceNavigate';
import { selectConfigExpressTaxEnabled } from '../store/slices/config/configSelectors';
import { selectLicense } from '../store/slices/licenseView/licenseViewSelectors';
import { resetRenewState } from '../store/slices/renew/renewSlice';
import {
  getLicenseAsync,
  getReportingHistoryByApplicationNumberAsync,
} from '../store/slices/licenseView/licenseViewThunks';
import { resetUpdateState } from '../store/slices/update/updateSlice';
import { useAppDispatch } from '../store/store';

const SinglePermit = () => {
  const { applicationNumber } = useParams<{ applicationNumber: string }>();

  const dispatch = useAppDispatch();
  const placeNavigate = usePlaceNavigate();

  // --- config selectors ---
  const taxEnabled = useSelector(selectConfigExpressTaxEnabled);

  // --- licenseView selectors ---
  const license = useSelector(selectLicense);

  useEffect(() => {
    dispatch(getLicenseAsync(applicationNumber));
    dispatch(getReportingHistoryByApplicationNumberAsync(applicationNumber));
    dispatch(resetUpdateState());
    dispatch(resetRenewState());
  }, [dispatch, applicationNumber]);

  const handleBackClick = useCallback(() => {
    placeNavigate('/dashboard');
  }, [placeNavigate]);

  return (
    <FlexboxGrid justify="space-between">
      <FlexboxGrid.Item colspan={24}>
        <PortalHeader />
      </FlexboxGrid.Item>

      <FlexboxGrid.Item
        aria-label="Single Permit View"
        as="main"
        colspan={24}
        id="main-content"
        tabIndex={-1}
      >
        <Grid
          className="ph-24 pb-24 sm-page-padding"
          fluid
        >
          <Row className="mt-24">
            <Col xs={24}>
              <Button
                appearance="subtle"
                className="link-gray"
                onClick={handleBackClick}
              >
                &lt; Back
              </Button>
            </Col>
          </Row>
          <Row style={{ marginBottom: '50px' }}>
            <Col xs={24}>
              <Header applicationNumber={applicationNumber} />
            </Col>
          </Row>
          <Row gutter={45}>
            <Col
              lg={8}
              lgPush={16}
              xs={24}
            >
              <PropertyContacts applicationNumber={applicationNumber} />
            </Col>
            {taxEnabled && (
              <Col
                lg={16}
                lgPull={8}
                xs={24}
              >
                <ReportingHistory
                  applicationNumber={applicationNumber}
                  license={license}
                />
              </Col>
            )}
          </Row>
        </Grid>
      </FlexboxGrid.Item>
    </FlexboxGrid>
  );
};

export default SinglePermit;
